import React from 'react'
import styles from './StepBadge.module.css'

type StepBadgeProps = {
    number: number
}

// DEV-3061 縦型EF用ステップ番号バッジ(「Q.」の代替)
export const StepBadge = ({ number }: StepBadgeProps) => {
    return <span className={styles.badge}>{number}</span>
}

export default StepBadge
